'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var component$x = require('./component-69c26fa4.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n\n  .picker-field {\n    box-sizing: border-box;\n    border: ", ";\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n\n  .picker-field {\n    box-sizing: border-box;\n    border: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.greys.adminGreyMedium;
});
var WheelPickerStyled = styled__default(component$x.WheelPicker)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  width: auto;\n  left: 16px;\n  right: 16px;\n  margin: 0;\n  background-color: ", ";\n  z-index: 99;\n\n  .wheel-picker-item {\n    font-size: 23px;\n  }\n"], ["\n  position: fixed;\n  bottom: 0;\n  width: auto;\n  left: 16px;\n  right: 16px;\n  margin: 0;\n  background-color: ", ";\n  z-index: 99;\n\n  .wheel-picker-item {\n    font-size: 23px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var templateObject_1, templateObject_2;

exports.Container = Container;
exports.WheelPickerStyled = WheelPickerStyled;
